<template>
    <st-checkbox-styled>
        <input v-model="_checked" type="checkbox" @change="changeHandler" />
        <div class="st-checkbox">
            <span class="ripple" v-for="item in ripple" :key="item.key" />
        </div>
        <div>
            <slot />
        </div>
    </st-checkbox-styled>
</template>
<script>
import styled, { keyframes } from "vue-styled-components";
import CheckboxImage from "../assets/checkbox.png";
import { ripple } from "../styles/theme";

const props = {};

const StCheckboxStyled = styled("label", props)`
    display: inline-block;
    font-size: 1.4rem;
    color: ${props => props.theme.color.disabled};
    display: flex;
    align-items: center;
    user-select: none;

    input[type="checkbox"] {
        display: none;

        &:checked {
            & + .st-checkbox {
                background-position-x: 0px;
            } 
        }
    }

    .st-checkbox {
        position: relative;
        width: 16px;
        height: 16px;
        margin-right: 8px;
        background-image: url('${CheckboxImage}');
        background-size: cover;
        background-position-x: -16px;

        .ripple {
            position: absolute;
            display: block;
            width: 24px;
            height: 24px;
            background-color: ${props => props.theme.color.primary};
            border-radius: 50%;
            left: 50%;
            top: 50%;
            z-index: -1;
            transform: translate(-50%, -50%) scale(0);
            opacity: 0;
            ${ripple}
        }
    }
`;

export default {
    name: "StCheckbox",
    data: () => ({
        ripple: [],
        key: 0
    }),
    props: {
        value: Boolean,
        ...props
    },
    computed: {
        _checked: {
            get() {
                return this.value;
            },
            set(value) {
                if (value) {
                    this.clickHandler();
                }

                this.$emit("input", value);
            }
        }
    },
    methods: {
        changeHandler(ev) {
            this.$emit("change", { ev, value: ev.target.checked });
        },

        clickHandler() {
            this.key++;
            this.ripple.push({ key: this.key });

            setTimeout(() => {
                this.deleteHandler(this.key);
            }, 350);
        },

        deleteHandler(key) {
            const index = this.ripple.findIndex(v => v.key.toString() === key.toString());
            this.ripple.splice(index, 1);
        }
    },
    components: {
        StCheckboxStyled
    }
};
</script>
